import React, {useEffect, useState} from 'react';
import {byCodes, getPostNum} from "../../../../constant/General";
import {getDate, getTime, getTimeFull} from "../../../../constant/DateUtils";

const LiveResult = ({rightResults, drawAt, ...props}) => {
    const [timer, setTimer] = useState(getTimeFull());
    let posts = byCodes(rightResults, ["F", "A", "B", "C", "D"]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(getTimeFull());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="w-50 overflow-hidden d-flex justify-content-center align-items-center">
            <div className="w-100 h-100">
                <div className="live-timer">{timer}</div>
                <div className="date-wrap">
                    <div className="live-current-date">{getDate(drawAt)}</div>
                    <div className="live-current-time">{getTime(drawAt)}</div>
                </div>
                <div style={{
                    fontSize: "54px",
                    marginLeft: "208px",
                }} className="post w-100">
                    {posts.map((post, i) => {
                        return <div
                            style={{
                                height: "93px",
                                marginBottom: "9px",
                                display: "flex",
                                fontWeight: "bold",
                                fontSize: "80px"
                            }}
                            className="d-flex" key={i}>
                            <div className="cen-div" style={{
                                marginRight: "17px", width: "145px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div className="cen-div" style={{
                                width: "240px"
                            }}>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
};

export default LiveResult;
